import React, { useState } from "react";
import { useAuth } from "../../Context/AuthContext";
import BeatLoader from "react-spinners/BeatLoader";
import { initializeCreateCheckoutSession } from "../../stripe/createCheckoutSession";
import { useHistory } from "react-router";
import { Row, Col } from "reactstrap";

const SubscriptionModal = () => {
  const {
    currentUser,
    usersData,
    activeStripeSubscriptionId,
    logout,
    sendVerificationEmail,
    isTrialAllowed,
  } = useAuth();
  const [loading, setLoading] = useState(false);
  const [loggedOut, setLoggedOut] = useState(false);
  const [delaySubscriptionId, setDelaySubscriptionId] = useState(false);
  const userName = usersData?.name;
  const history = useHistory();

  async function submitHandler(productId) {
    if (!currentUser) {
      alert("You must be logged in to make a purchase.");
      return;
    }

    setLoading(true);
    await initializeCreateCheckoutSession(
      currentUser.uid,
      productId,
      setLoading,
      isTrialAllowed
    );
  }

  function handleLogout() {
    logout();
    history.push("/login");
    setLoggedOut(true);
  }
  const handleSubmitVerification = () => {
    sendVerificationEmail();
  };
  React.useEffect(() => {
    const delay = setTimeout(() => {
      setDelaySubscriptionId(true);
    }, 700);
    return () => clearTimeout(delay);
  }, [activeStripeSubscriptionId]);

  const showCustomerCheckoutInfo = () => {
    return (
      <>
        {delaySubscriptionId && (
          <>
            {activeStripeSubscriptionId ? (
              ""
            ) : (
              <Row className="outer-box-subscription">
                <Col className="inner-box-subscription p-3 pb-5">
                  {/*** Header  ***/}
                  <Row className="g-0">
                    <Col
                      xs={32}
                      className="offset-4 d-flex justify-content-center align-items-center card-heading fw-bold"
                    >
                      {usersData?.stripeId ? (
                        <p className="text-danger mb-0">
                          {" "}
                          Hej {userName}. Din avtalsperiod har tyvärr gått ut.
                          Välkommen att förnya ditt avtal.{" "}
                        </p>
                      ) : (
                        <p className="text-success mb-0">
                          {" "}
                          Hej {userName}. Välkommen att starta din dinBiZ{" "}
                        </p>
                      )}
                    </Col>

                    {/*** Logout button  ***/}
                    <Col
                      xs={4}
                      className="d-flex justify-content-end align-items-center"
                    >
                      <button
                        type="button"
                        className="btn btn-danger button-logout"
                        onClick={handleLogout}
                      >
                        Logga ut
                      </button>
                    </Col>
                  </Row>

                  {currentUser.emailVerified ? (
                    <Row className="g-0 d-flex justify-content-center mt-4">
                      <Col xs={20} className="p-5">
                        <p className="card-text">
                          <i>din</i>BiZ används oftast till att
                        </p>
                        <ul className="card-text">
                          <li>Testa en affärsidé – innan du satsar allt</li>
                          <li>Guida ditt affärsprojekt i Mål</li>
                          <li>Ha högsta lönsamhet i etablerad verksamhet</li>
                        </ul>
                        <p className="card-text">
                          Välj och byt därför fritt efter behov: <br />
                          <b> per månad</b> eller <b>per år</b> full tillgång
                          till <i>din</i>BiZ <br />
                          (Bytt val gäller från att det gamla löpt ut)
                        </p>
                        <p className="card-text">
                          Vid avslutat konto har du fortsatt tillgång till{" "}
                          <i>din</i>BiZ <br />
                          den tid du betalt för och är Varmt Välkommen tillbaka.
                        </p>
                      </Col>

                      <Col xs={20} className="p-5">
                        <p className="card-text text-center lead fw-bold text-muted">
                          Välj abonnemang för 30 dagar eller 12 månader <br />
                          oavsett val får du tillgång till 30 dagars gratis
                          provperiod
                        </p>
                        <Row className="g-0 mt-1">
                          <Col xs={16} className="offset-22">
                            <p className="card-text-small mb-0 text-primary text-center fw-bold">
                              (*alla priser exkl.moms)
                            </p>
                          </Col>
                        </Row>

                        {/*** Buttons ***/}
                        <Row className="g-0 d-flex mt-5">
                          <Col
                            xs={16}
                            className="offset-3 bg-light p-4 rounded"
                          >
                            <p className="card-text text-center mb-0 lead fw-bold text-muted">
                              <i>din</i>BiZ
                            </p>
                            <p className="card-text text-center lead fw-bold text-muted mb-1">
                              30 dagar
                            </p>
                            <p className="card-text-big text-center lead fw-bold text-primary">
                              *39:-
                            </p>
                            <div className="d-flex justify-content-center align-items-center">
                              <button
                                className="btn btn-success card-button ps-4 pe-4"
                                onClick={
                                  loading
                                    ? () => {}
                                    : () =>
                                        submitHandler(
                                          `${process.env.REACT_APP_STRIPE_SUBSCRIPTION_PRICE_ID}`
                                        )
                                }
                                disabled={loading}
                              >
                                {loading ? (
                                  <BeatLoader loading={loading} size={5} />
                                ) : (
                                  "Ja Tack"
                                )}
                              </button>
                            </div>
                          </Col>
                          <Col
                            xs={16}
                            className="offset-3 bg-light p-4 rounded"
                          >
                            <p className="card-text text-center mb-0 lead fw-bold text-muted">
                              <i>din</i>BiZ
                            </p>
                            <p className="card-text text-center mb-1 lead fw-bold text-muted">
                              12 månader
                            </p>
                            <p className="card-text-big text-center lead fw-bold text-primary">
                              *336:-
                            </p>
                            <div className="d-flex justify-content-center align-items-center mt-2">
                              <button
                                className="btn btn-success card-button ps-4 pe-4"
                                onClick={
                                  loading
                                    ? () => {}
                                    : () =>
                                        submitHandler(
                                          `${process.env.REACT_APP_STRIPE_ANNUAL_SUBSCRIPTION_PRICE_ID}`
                                        )
                                }
                                disabled={loading}
                              >
                                {loading ? (
                                  <BeatLoader loading={loading} size={5} />
                                ) : (
                                  "Ja Tack"
                                )}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <>
                      <Row className="g-0 d-flex align-items-center justify-content-center mt-5">
                        <Col xs={30}>
                          <p className="card-text mb-0">
                            Vänligen titta i din mejl och klicka på länken för
                            att verifiera ditt konto. Om du inte fått en länk
                            vänligen titta i din skräppost. Får du bestående
                            problem med verifieringsmailet är du välkommen att
                            kontakta Kundservice hos SFR på telnr: X för vidare
                            hjälp.
                          </p>
                          <p className="card-text mb-0">
                            Efter det är det bara att uppdatera sidan och välja
                            vilken tillgång som passar dig och <i>din</i>BIZ.
                          </p>
                        </Col>
                      </Row>
                      <div className="g-0 d-flex align-items-center justify-content-around mt-5">
                        <button
                          className="btn btn-success card-button"
                          onClick={handleSubmitVerification}
                        >
                          Skicka ny verifieringslänk
                        </button>
                        <button
                          className="btn btn-success card-button"
                          onClick={() => window.location.reload()}
                        >
                          Jag har verifierat mig
                        </button>
                      </div>
                    </>
                  )}
                </Col>
              </Row>
            )}
          </>
        )}
      </>
    );
  };

  return <>{loggedOut ? "" : !currentUser ? "" : showCustomerCheckoutInfo()}</>;
};

export default SubscriptionModal;
